import { Typography } from '@mui/material';

export const RequiredAsterisk = () => {
  return (
    <Typography
      component="span"
      sx={{
        fontSize: '15px',
        fontWeight: 500,
        lineHeight: 1.2,
        color: 'custom.requiredAsterisk',
      }}
    >
      *
    </Typography>
  );
};
